<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>デフォルト予約</v-toolbar>
        <v-card-text>
          <v-card-text>
            <v-row >
              <v-col :cols="3"></v-col>
              <v-col :cols="3" v-for="(item,index) in weekClasses" :key="index">
                {{item.weekName}}
              </v-col>
            </v-row>
            <v-row v-for="(item,index) in defaultReserveInfos" :key="index">
              <v-col :cols="3"> {{item.meal_name}}</v-col>
              <v-col>
                <v-icon large color="blue" v-if="item.week_day" @click="item.week_day = !item.week_day">
                  mdi-check-circle
                </v-icon>
                <v-icon large v-if="!item.week_day" @click="item.week_day = !item.week_day">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </v-col>
              <v-col>
                <v-icon large color="blue" v-if="item.week_sat" @click="item.week_sat = !item.week_sat">
                  mdi-check-circle
                </v-icon>
                <v-icon large v-if="!item.week_sat" @click="item.week_sat = !item.week_sat">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </v-col>
              <v-col>
                <v-icon large color="blue" v-if="item.week_sun" @click="item.week_sun = !item.week_sun">
                  mdi-check-circle
                </v-icon>
                <v-icon large v-if="!item.week_sun" @click="item.week_sun = !item.week_sun">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox v-model="nextReserveFlg" :value="nextReserveFlg" :label="'月次予約未登録時、自動予約を行う。'"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'">
            </ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'設定'" :handlerClick="confirm">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  export default {
    name: "MealReservationDefaultDialog",
    components: {
      RyouBlackBtn,
      RyouConfirm,
    },
    data() {
      return {
        dialog: false,
        buildGroupId: "",
        userId: "",
        nextReserveFlg:false,
        defaultReserveInfos: [],
        weekClasses: [
          { weekClass:0, weekName:"平日" },
          { weekClass:1, weekName:"土曜" },
          { weekClass:2, weekName:"日曜" },
        ]
      };
    },
    watch: {
    },
    methods: {
      //確認キャンセル
      handleCancel() {
        this.close();
      },
      //確認
      confirm() {
        this.$refs.confirm.open("更新", "更新します。宜しいですか？", { color: "info" })
          .then((confirm) => {
            if (confirm) {
              this.updateDefaultReservation()
            }
          });
      },
      //ダイアログを閉じる
      close() {
        this.dialog = false;
      },
      //ダイアログを表示する
      open(buildGroupId, userId) {
        this.buildGroupId = buildGroupId
        this.userId = userId
        this.dialog = true;
        this.fetchDefaultData();
      },
      //DBよりデフォルト予約条件データを取得する
      fetchDefaultData() {
        let params = {
          userId:this.userId,
          buildGroupId:this.buildGroupId
        }
        this.getRequest("/mealReservation/mealDefaulReserveGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success && data.status == "200") {
                  
            //数値を真偽値に変換する
            this.nextReserveFlg = Boolean(data.result.next_reserve_flg)
            var mapDatas = data.result.mealList.map(item => {
              item.week_day = Boolean(item.week_day)
              item.week_sat = Boolean(item.week_sat)
              item.week_sun = Boolean(item.week_sun)
              return item
            });
            this.defaultReserveInfos = mapDatas;
          }
        });

        //let result = {
        //  buildGroupId: "1",
        //  userId: "124816",
        //  next_reserve_flg:1,
        //  list: [
        //    {meal_class: 1, meal_name: "朝食", week_day: 1, week_sat: 0, week_sun: 0 },
        //    {meal_class: 2, meal_name: "夕食A", week_day: 1, week_sat: 0, week_sun: 0 },
        //    {meal_class: 3, meal_name: "夕食B", week_day: 1, week_sat: 0, week_sun: 0 }
        //  ]
        //}
        //
        ////数値を真偽値に変換する
        //this.nextReserveFlg = Boolean(result.next_reserve_flg)   
        //var mapDatas = result.list.map(item => {
        //      item.week_day = Boolean(item.week_day)
        //      item.week_sat = Boolean(item.week_sat)
        //      item.week_sun = Boolean(item.week_sun)
        //      return item
        //    });
        //    this.defaultReserveInfos = mapDatas;

        
      },
      //デフォルト予約条件更新
      updateDefaultReservation()
      {
        //真偽値を数値に変換する
        this.defaultReserveInfos.map(item => {
          item.week_day = Number(item.week_day)
          item.week_sat = Number(item.week_sat)
          item.week_sun = Number(item.week_sun)
        })
        let params = {
          build_group_id: this.buildGroupId,
          user_id: this.userId,
          next_reserve_flg: Number(this.nextReserveFlg),
          list: this.defaultReserveInfos
        }
        this.putRequest("/mealReservation/mealDefaultReserveUpdate", params, this.$store.getters.getUserToken).then((resp) => {
          if (resp.success) {
            this.close();
          }
        });
      }
    }
  }
</script>

<style scoped>
  .noPadding {
    padding: 0px;
  }

  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>